// Modal.js
import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import saveIcon from '../../../public/assets/images/saveIcon.png';
const PopupModal = ({ isOpen, message, type, time, onClose }) => {
  useEffect(() => {
    if (isOpen && time) {
      const timer = setTimeout(() => {
        onClose();
      }, time);

      return () => clearTimeout(timer);
    }
  }, [isOpen, time, onClose]);

  if (!isOpen) return null;

  const icon =
    type === 'Fail' ? (
      <FontAwesomeIcon icon={faCircleXmark} size="2x" color="#A04D95" />
    ) : (
      <img src={saveIcon} alt="saveIcon" height={'50px'} width={'50px'} />
    );
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 backdrop-blur-lg lg:w-full lg:h-full">
      <div className="bg-white  shadow-xl h-[190px] w-[301px] p-10 rounded-md">
        <div className="flex items-center justify-center mb-4">
          <span className="text-3xl">{icon}</span>
        </div>
        <p className="mt-4 text-center text-base font-semibold text-primary pt-4">
          {message}
        </p>
      </div>
    </div>
  );
};

export default PopupModal;
